import { z } from 'zod';
import { CompanyDataSchema } from 'stores/CompanyStore/types';
import { ActionTypeSchema } from './actionTypes';
import { ProductSchema, ProductIdSchema, AddProductSchema } from '../products';
import { AccountSchema } from '../accounts';
import { UserSchema, UserIdSchema } from '../users';
import { TeamSchema } from '../teams';
import { GoalUpdateSchema } from '../goals';
import { NotificationSchema } from '../notifications';
export var loginSchema = z.object({
    type: ActionTypeSchema.extract(['LOGIN'])
});
export var logoutSchema = z.object({
    type: ActionTypeSchema.extract(['LOGOUT'])
});
export var updateDataSchema = z.object({
    type: ActionTypeSchema.extract(['UPDATE_COMPANY_STORE']),
    data: CompanyDataSchema.partial()
});
export var showLoaderSchema = z.object({
    type: ActionTypeSchema.extract(['SHOW_GLOBAL_LOADER'])
});
export var addProductSchema = z.object({
    type: ActionTypeSchema.extract(['ADD_PRODUCT']),
    data: AddProductSchema
});
export var updateAccountSchema = z.object({
    type: ActionTypeSchema.extract(['UPDATE_ACCOUNT']),
    data: AccountSchema.partial()
});
export var updateProductSchema = z.object({
    type: ActionTypeSchema.extract(['UPDATE_PRODUCT']),
    id: ProductIdSchema,
    data: ProductSchema.partial()
});
export var updatePlayerSchema = z.object({
    type: ActionTypeSchema.extract(['UPDATE_PLAYER']),
    id: UserIdSchema,
    data: UserSchema.partial()
});
export var updateTeamSchema = z.object({
    type: ActionTypeSchema.extract(['UPDATE_TEAM']),
    id: z.string(),
    data: TeamSchema.partial()
});
export var updateGoalSchema = z.object({
    type: ActionTypeSchema.extract(['UPDATE_GOAL']),
    data: GoalUpdateSchema
});
export var updateNotificationSchema = z.object({
    type: ActionTypeSchema.extract(['UPDATE_NOTIFICATION']),
    data: NotificationSchema
});
export var CompanyStateActionsSchema = z.discriminatedUnion('type', [
    updateDataSchema,
    showLoaderSchema,
    addProductSchema,
    updateAccountSchema,
    updateProductSchema,
    updatePlayerSchema,
    updateTeamSchema,
    updateGoalSchema,
    updateNotificationSchema
]);
